import CloseIcon from '@mui/icons-material/Close';
import { Box } from '@mui/material';
import SnackbarContent from '@mui/material/SnackbarContent';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import { tracker } from 'app-components/utils/core';
import QButton from 'components/QButton';
import * as notificationsActions from 'data/notifications/notificationsActions';
import PropTypes from 'prop-types';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const NotificationGamificationContent = React.forwardRef((props, ref) => {
  const { milestoneData, id } = props;
  const theme = useTheme();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  return (
    <SnackbarContent
      aria-describedby='hello-world'
      ref={ref}
      message={
        <Box
          display={'flex'}
          alignItems={'center'}
          position={'relative'}
          width={'495px'}
          justifyContent={'space-between'}
        >
          <Box display={'flex'} flexDirection={'column'}>
            <Typography variant='bodyMedium' color={theme.palette.text.primary}>
              You earned a badge!
            </Typography>
            <Box display={'flex'} alignItems={'center'} paddingTop={'3px'}>
              <img
                src={milestoneData[0].imageLink}
                alt={'milestone-img'}
                style={{ height: 56, width: 56, marginRight: 8 }}
              />
              <Typography variant='bodyRegular' color={theme.palette.text.primary}>
                {milestoneData[0]?.content?.nameLevel}
              </Typography>
            </Box>
          </Box>
          <CloseIcon
            style={{
              position: 'absolute',
              right: -12,
              top: 0,
              color: theme.palette.text.primary,
              height: 20,
            }}
            onClick={() => dispatch(notificationsActions.removeNotifications([id]))}
          />
          <QButton
            // style={{ marginLeft: 150 }}
            onClick={() => {
              navigate('/achievements');
              dispatch(notificationsActions.removeNotifications([id]));
              tracker.track(tracker.events.achievementsPageView, { initiator: 'snackbar' });
            }}
          >
            VIEW ALL
          </QButton>
        </Box>
      }
      style={{
        backgroundColor: theme.palette.background.paper,
        height: '100%',
        width: '100%',
        borderRadius: 8,
      }}
    />
  );
});

NotificationGamificationContent.propTypes = {
  id: PropTypes.string,
  milestoneData: PropTypes.array,
};
NotificationGamificationContent.displayName = 'NotificationGamificationContent';
export default NotificationGamificationContent;
